import { CSSProperties } from "@material-ui/core/styles/withStyles";

const syncing: CSSProperties = {
  padding: `5px 6px 10px`,
  color: "white",
  fontSize: 14,
  lineHeight: 1.4,
  WebkitFontSmoothing: "antialiased",
};

export const styles = {
  syncing,
};
